export default __webpack_public_path__ + "media/src/assets/images/PickupLinehaul-cc546b4c1f550dabc2e27f97a9d97f19.svg";